import React from "react";
import { ICustomer } from "../../interfaces/customer";
import { IPets } from "../../interfaces/pets";
import { getAllCustomersActive } from "../../services/customer.service";

export default function useCustomerManagementPag() {
  const [showArrow, setShowArrow] = React.useState<number>(-1);
  const [showCardCustomer, setShowCardCustomer] = React.useState<number>(-1);
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [customerData, setCustomerData] = React.useState<ICustomer[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [isShowModelPets, setIsShowModelPets] = React.useState<boolean>(false);
  const [dataModalPets, setDataModalPets] = React.useState<IPets[]>([]);

  const ToggleToShow = (index: number) => {
    setShowArrow(index);
    setShowCardCustomer(index);
  };

  const ToggleModal = (showModal: boolean) => {
    setShowModal(!showModal);
  };

  const handleShowModalPets = (pets: IPets[]) => {
    setDataModalPets(pets);
    setIsShowModelPets(true);
  };

  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    setShowCardCustomer(-1);
    const res = await getAllCustomersActive();
    const data = res.data;
    setCustomerData(data);
    setIsLoading(false);
  }, []);
  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    customerData,
    ToggleToShow,
    showArrow,
    isLoading,
    showCardCustomer,
    ToggleModal,
    handleShowModalPets,
    fetchData,
    showModal,
    isShowModelPets,
    dataModalPets,
    setIsShowModelPets,
  };
}
